/**
 * What the expert index is asked for: the text as typed, without the spaces around it.
 *
 * Typing "carbone " or a box holding only spaces is not a different search. Sent as typed, the
 * trailing space made a second query with its own cache entry, and a box of spaces reordered the
 * list and counted as a search in the analytics.
 */
export function normalizeSearchQuery(typed: string): string {
  return typed.trim();
}
